var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"product-attribute text-sm"},[_vm._v("\n  "+_vm._s(_vm.label)+":\n  "),_c('span',{attrs:{"itemprop":_vm.hasSchema ? _vm.SCHEMA_ITEM_PROP.SKU : undefined}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }